//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "County",
};
